// Google Analytics 4 — gtag.js loader + pageview tracker
// Measurement ID comes from REACT_APP_GA4_MEASUREMENT_ID (format: "G-XXXXXXXXXX")
// Silently no-ops when the env var is unset (e.g. preview / dev).

const GA_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID || "";
let injected = false;

// Read UTM params from the current URL once; GA4 auto-attaches them to campaign_* fields
const readUtms = () => {
  try {
    const p = new URLSearchParams(window.location.search);
    const utm = {};
    ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"].forEach(k => {
      const v = p.get(k);
      if (v) utm[k] = v;
    });
    return utm;
  } catch { return {}; }
};

const inject = () => {
  if (injected || !GA_ID || typeof window === "undefined") return;
  injected = true;

  // 1) gtag.js script tag
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);

  // 2) dataLayer + gtag() shim
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());

  // 3) Initial config — disable auto page_view; we send manually on route change
  const utm = readUtms();
  window.gtag("config", GA_ID, {
    send_page_view: false,
    ...utm,
  });
};

export const trackPageview = (path, title) => {
  if (!GA_ID) return;
  inject();
  if (typeof window === "undefined" || !window.gtag) return;
  const utm = readUtms();
  window.gtag("event", "page_view", {
    page_path: path,
    page_title: title || document.title,
    page_location: window.location.href,
    ...utm,
  });
};

export const trackEvent = (name, params = {}) => {
  if (!GA_ID) return;
  inject();
  if (typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", name, params);
};

export const isAnalyticsEnabled = () => !!GA_ID;
